import * as React from 'react';

import * as styles from './buttonLink.scss';
import ArrowDown from 'components/svg/ArrowDown';
import ArrowRight from 'components/svg/ArrowRight';

type Props = {
    arrowDown?: boolean;
    arrowRight?: boolean;
    arrowLeft?: boolean;
    className?: string;
    liftEventInfo?: (event: any) => void;

}

const ButtonLink: React.SFC<Props> = props => {


    const handleOnClick = (event: any):void => {
        if ( typeof props.liftEventInfo !== 'undefined' ) {
            props.liftEventInfo(event);
        }
    }


    return (
        <>
            {props.arrowLeft?
            <ArrowRight className={styles.arrow+' '+styles.arrowLeft}/>
                : ''
                }
            <button
                type={'button'}
                className={styles.button + (props.className ? ' ' + props.className : '')}
                onClick={handleOnClick}
            >
                {props.children}
                {props.arrowDown?
                    <ArrowDown className={styles.arrow}/>
                    : ''
                }

                {props.arrowRight?
                    <ArrowRight className={styles.arrow}/>
                    : ''
                }
            </button>
        </>
    )
}



export default ButtonLink;